import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { ReducedWorkSchedule, ReducedWorkScheduleItem } from '../models';

export class ReducedWorkScheduleApi extends ApiModule {
  protected endpoint = '/reduced-work-schedule';

  public async pageReducedWorkSchedules(params: any) {
    return this.api.post<PaginatedResponseData<ReducedWorkScheduleItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadReducedWorkScheduleDetails(id: number) {
    return this.api.get<ReducedWorkSchedule>(`${this.endpoint}?id=${id}`);
  }

  public saveReducedWorkSchedule(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public listPeriodReducedWorkSchedules(fromDate: string, toDate: string, educationId: number) {
    return this.api.post<ReducedWorkSchedule[], any>(`${this.endpoint}/period-elements`, {
      fromDate,
      toDate,
      educationId
    });
  }

  public deleteReducedWorkSchedule(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
